import { WHILSCO } from "@/constants/testIds";
import { ZafaraLogoMark } from "@/components/landing/Logo";
import { useContent } from "@/context/ContentContext";

export const WhilscoDigit = () => {
  const { content } = useContent();
  const c = content.company;

  return (
    <section
      id="whilsco"
      data-testid={WHILSCO.root}
      className="relative py-24 md:py-28 bg-white"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <p className="font-utility text-xs uppercase tracking-[0.25em] text-[#0E7A3B]">
            L'éditeur
          </p>
          <h2 className="mt-4 font-display text-4xl md:text-5xl text-[#16241B] leading-[1.05] tracking-tighter">
            Zafara est éditée par{" "}
            <span className="text-[#0E7A3B]">Whilsco-Digit {c.form}</span>.
          </h2>
          <p className="mt-6 text-lg text-[#16241B]/75 leading-relaxed">
            Un studio produit basé au Bénin, qui construit des applications
            utiles pour l'Afrique de l'Ouest — bâties sur le terrain, à
            l'écoute des vraies contraintes locales.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-5">
          <div className="group relative overflow-hidden rounded-3xl border border-[#EDE7D9] bg-[#FBFAF6] p-7 hover:-translate-y-1 transition-transform duration-500">
            <ZafaraLogoMark className="h-12 w-12" />
            <div className="mt-6 flex items-center gap-2">
              <span className="inline-flex items-center rounded-full bg-[#0E7A3B] text-white px-2.5 py-0.5 text-[10px] font-utility uppercase tracking-widest">
                Application phare
              </span>
              <span className="inline-flex items-center rounded-full bg-[#F5A800] text-[#16241B] px-2.5 py-0.5 text-[10px] font-utility uppercase tracking-widest">
                Live
              </span>
            </div>
            <p className="mt-4 font-display text-2xl text-[#16241B] tracking-tight">
              Zafara Bénin
            </p>
            <p className="mt-2 text-sm text-[#16241B]/65">
              L'appli du quotidien au Bénin.
            </p>
          </div>

          {[0, 1].map((i) => (
            <div
              key={i}
              className="rounded-3xl border-2 border-dashed border-[#EDE7D9] p-7 flex flex-col items-start justify-center min-h-[220px]"
            >
              <div className="h-12 w-12 rounded-2xl bg-[#FBFAF6] border border-[#EDE7D9] flex items-center justify-center text-[#16241B]/30 font-display text-2xl">
                +
              </div>
              <p className="mt-6 font-display text-lg text-[#16241B]/60 tracking-tight">
                Nouvelle app
              </p>
              <p className="mt-1 text-xs text-[#16241B]/40 font-utility uppercase tracking-widest">
                À venir
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-4">
          {[
            { l: "Siège", v: c.siege },
            { l: "Forme juridique", v: `Whilsco-Digit ${c.form}` },
            { l: "Contact", v: c.email },
          ].map((b) => (
            <div key={b.l} className="rounded-2xl bg-[#FBFAF6] border border-[#EDE7D9] p-5">
              <p className="font-utility text-[10px] uppercase tracking-widest text-[#0E7A3B]">
                {b.l}
              </p>
              <p className="mt-2 font-display text-base text-[#16241B] tracking-tight">
                {b.v || "—"}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
